<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">

                    <b-col cols="4">
                        <LgFinderPageItemBemPermanente v-model="form.ibp" :prefix="[prefix, title]"
                            @onselect='itemBemPermanenteSelect' id="itemBemPermanenteHistoricoEdicao"
                            label="Item Bem Permanente:">
                        </LgFinderPageItemBemPermanente>
                    </b-col>

                    <b-col cols="4">
                        <LgFinderPageUnidadeAdministrativa v-model="form.departamento" :prefix="prefix + title + ' > '"
                            @onselect='departamentoSelect' id="LgFinderPageUnidadeAdministrativaHistoricoEdicao">
                        </LgFinderPageUnidadeAdministrativa>
                    </b-col>

                    <b-col cols="4">
                        <LgFinderPageLocalArmazenamento :prefix="prefix + title + ' > '" id="finderLocalArmazenamentoModalHistoricoEdicao"
                            v-model="form.local" label="Localização Física:" @input="handleSelectLocalArmazenamento" />

                    </b-col>

                    <b-col cols="4">
                        <LgFinderPagePessoa v-model="form.pessoa" :prefix="prefix + title + ' > '"
                            @onselect='pessoaSelect' id="pessoaSelectHistoricoEdicao">
                        </LgFinderPagePessoa>
                    </b-col>


                    <b-col cols="4">
                        <lg-form-date invalidFeedback=" " v-model="form.dataDe" label="Data de:" description="" />

                    </b-col>

                    <b-col cols="4">
                        <lg-form-date invalidFeedback=" " v-model="form.dataAte" label="Data Até:" description="" />

                    </b-col>

                    <b-col cols="12" class="d-flex justify-content-end mt-2">

    

                        <b-button id="limpar-historicoEdicao" class="my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar-historicoEdicao" title="Limpar"></b-tooltip>
                        </b-button>


                        <b-button id="localizarHistoricoEdicao" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarHistoricoEdicao" title="Localizar"></b-tooltip>

                        </b-button>



                    </b-col>


                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFinderPageItemBemPermanente from "@/components/Finders/LgFinderPageItemBemPermanente.vue";
import moment from "moment"
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import PdfIcon from "@/core/assets/icons/pdf.png";
import xlsIcon from "@/core/assets/icons/xls.png";
import odsIcon from "@/core/assets/icons/ods.png";


import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";

export default {
    components: {
        LgFinderPagePessoa,
        LgFinderPageItemBemPermanente,
        LgFormDate,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPageLocalArmazenamento
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            title: 'Histórico Edição Item Bem Permanente',
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            form: {
                local: {},
                departamento: {},
                ibp: {},
                pessoa: {},
                dataDe: "",
                dataAte: "",
            },
            pdf: PdfIcon,
            xlsIcon: xlsIcon,
            ods: odsIcon
                            
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/historico-edicao-ibp`);
    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                { key: "numTombamento", label: "Tombamento" },
                { key: "numTombamentoSAMP", label: "Tombamento Antigo" },
                { key: "pessoa", label: "Responsável Alteração" },
                { key: "data", label: "Data Alteração", formatter: (value) => moment(value).format('DD/MM/YYYY HH:mm') },
                { key: "alteracao", label: "Alterações" },

            ];
        },
    },
    methods: {
        handleSelectLocalArmazenamento(item){
            this.form.local = item;
            this.load();
        },
        departamentoSelect(departamento) {
            this.form.departamento = departamento;
            this.load();
        },
        clearForm() {

            this.form = {
                local: {},
                departamento: {},
                ibp: {},
                pessoa: {},
                dataDe: "",
                dataAte: "",
            }
            this.load();
        },
        pessoaSelect(pessoa) {
            this.form.pessoa = pessoa;
            this.load();
        },

        itemBemPermanenteSelect(ibp) {
            this.form.ibp = ibp;
            this.load();

        },
        async load() {
            this.filtro = {};
            this.busy = true;

            if (this.form.local && this.form.local.id)
                this.filtro.local = this.form.local.id;

            if (this.form.departamento && this.form.departamento.id)
                this.filtro.departamento = this.form.departamento.id;

            if (this.form.dataDe != "")
                this.filtro.dataDe = moment(String(this.form.dataDe)).format(
                    "DD/MM/YYYY"
                );

            if (this.form.dataAte != "")
                this.filtro.dataAte = moment(String(this.form.dataAte)).format(
                    "DD/MM/YYYY"
                );
            if (this.form.pessoa && this.form.pessoa.id) {
                this.filtro.pessoa = this.form.pessoa.id;
            }

            if (this.form.ibp && this.form.ibp.id) {
                this.filtro.ibp = this.form.ibp.id;
            }

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

        },

    },
};
</script>